module.exports = __webpack_public_path__ + "b437287811d531f3eda74b7fdc0d92be.png";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/BRaVE-logo-white.png
// module id = 1348
// module chunks = 17